"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasChange = exports.calculateClaims = void 0;
const fast_deep_equal_1 = __importDefault(require("fast-deep-equal"));
const isTypedString = (s, types) => types.includes(s);
const calculateClaims = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
authEmailsSnapshots, externalAuthorizationSnapshots) => {
    let claim;
    authEmailsSnapshots.forEach((doc) => {
        var _a, _b, _c;
        const projectId = (_b = (_a = doc.ref.parent) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.id;
        const role = (_c = doc.data()) === null || _c === void 0 ? void 0 : _c.role;
        if (projectId && isTypedString(role, ["master", "user"])) {
            claim = Object.assign(Object.assign({}, claim), { projectRoles: Object.assign(Object.assign({}, claim === null || claim === void 0 ? void 0 : claim.projectRoles), { [projectId]: role }) });
        }
        else if (isTypedString(role, ["master"])) {
            claim = Object.assign(Object.assign({}, claim), { role });
        }
    });
    externalAuthorizationSnapshots === null || externalAuthorizationSnapshots === void 0 ? void 0 : externalAuthorizationSnapshots.forEach((doc) => {
        var _a;
        const roles = (_a = doc.data()) === null || _a === void 0 ? void 0 : _a["roles"];
        if (roles) {
            claim = Object.assign(Object.assign({}, claim), { projectRoles: Object.assign(Object.assign({}, claim === null || claim === void 0 ? void 0 : claim.projectRoles), roles) });
        }
    });
    return Object.assign(Object.assign({}, claim), { projectIds: Object.keys((claim === null || claim === void 0 ? void 0 : claim.projectRoles) || {}) });
};
exports.calculateClaims = calculateClaims;
const hasChange = (remoteClaims, _localClaims = {}) => {
    const localClaims = Object.fromEntries(["role", "projectRoles", "projectIds"]
        .map((key) => [key, _localClaims[key]])
        .filter(([, value]) => value !== undefined));
    localClaims.projectIds = localClaims.projectIds || [];
    const hasChange = !(0, fast_deep_equal_1.default)(remoteClaims, localClaims);
    console.log("check change#", hasChange, remoteClaims, localClaims);
    return hasChange;
};
exports.hasChange = hasChange;
